import React, { useEffect } from "react";
import { Play } from "lucide-react"; // Play icon
import bingoImg from "../assets/balls-BDjg0rhe.png"; // ← place your image in /src/assets/
import Navbar2 from "../components/navbar/Navbar2";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import crazyImg from "../assets/kenologo.jpg";
import BingoImg from "../assets/bingo1.avif";

const games = [
  { name: "Bingo Games", link: "betamountpage", image: BingoImg },
  { name: "Fast Keno", link: "keno-game", image: crazyImg },
];

export default function HomePage() {
  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 500,
      easing: "ease-in-sine",
      delay: 100,
    });
    AOS.refresh();
  }, []);

  const navigate = useNavigate();

  const handlePlay = () => {
    navigate("/betamountpage"); // Navigate to bitamount page
  };

  return (
    <>
      <div className="fixed left-0 right-0 top-0 z-50 bg-gradient-to-l from-violet-900 via-violet-800 to-violet-900 ">
        {/* <Navbar /> */}
        <Navbar2 />
      </div>
      <div className="min-h-screen bg-[#0b3557] flex flex-col justify-center items-center px-4 py-10 sm:py-16 pt-20">
        {/* Main Section */}
        <div className="flex flex-col-reverse lg:flex-row items-center justify-between w-full max-w-6xl gap-10 lg:gap-20">
          {/* Left Section: Bingo Card */}
          <div className="bg-gradient-to-r from-[#123f63] to-[#0b3557] shadow-2xl rounded-2xl p-8 sm:p-10 text-white w-full max-w-md">
            <div className="flex items-center gap-2 mb-1">
              <div className="w-2 h-2 bg-cyan-400 rotate-45"></div>
              <h2 className="text-lg font-semibold text-gray-200">Leo Games</h2>
            </div>
            <p className="text-gray-400 text-sm mb-2">
              Try the most popular games and win big.
            </p>
            <div className="grid grid-cols-2 gap-2">
              {games.map((game) => (
                <div
                  key={game.name}
                  onClick={() => navigate(`/${game.link.toLowerCase()}`)}
                  className="relative group cursor-pointer rounded-xl overflow-hidden border border-cyan-400 bg-[#0f3b63] shadow-[0_0_8px_rgba(34,211,238,0.4)]"
                >
                  {/* Image Section */}
                  <div className="relative">
                    <img
                      src={game.image}
                      alt={game.name}
                      className="w-full h-36 object-cover transition duration-300 group-hover:scale-110"
                    />

                    {/* Hover Overlay */}
                    <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition duration-300 flex items-center justify-center">
                      <div className="w-14 h-14 rounded-full bg-white/80 flex items-center justify-center shadow-lg">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-6 h-6 text-gray-800 ml-1"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M8 5v14l11-7z" />
                        </svg>
                      </div>
                    </div>
                  </div>

                  {/* Title Panel */}
                  <div className="bg-gradient-to-r from-cyan-700 via-cyan-600 to-cyan-700 text-center py-2">
                    <p className="text-white font-semibold text-sm tracking-wide">
                      {game.name}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Section: Bingo Image */}
          <div className="flex justify-center w-full lg:w-1/2">
            <img
              src={bingoImg}
              alt="Bingo Balls"
              className="w-64 sm:w-80 md:w-[420px] drop-shadow-2xl"
            />
          </div>
        </div>

        {/* Footer */}
        <div className="mt-12 text-center text-gray-300 text-sm font-serif">
          © {new Date().getFullYear()} Leo ቢንጎ | Play Responsibly
        </div>
      </div>
    </>
  );
}
